const TABLE_SWITCHER_TRACKING_NAMES = {
  powerBall: 'Without Power Play',
  powerPlay: 'With Power Play',
  megaMillions: 'Without Megaplier',
  megaPlier: 'With Megaplier',
} as const;

type TableSwitcherTrackingLotteryId = keyof typeof TABLE_SWITCHER_TRACKING_NAMES;

function getTableSwitcherTrackingName(lotteryId: string): string | undefined {
  if (!(lotteryId in TABLE_SWITCHER_TRACKING_NAMES)) {
    return undefined;
  }

  return TABLE_SWITCHER_TRACKING_NAMES[lotteryId as TableSwitcherTrackingLotteryId];
}

export { TABLE_SWITCHER_TRACKING_NAMES, getTableSwitcherTrackingName };
